// @flow

import type { DocumentType, OneQuoteDocuments } from './Types/DocumentTypes'
import type { TariffContentWithKeyType } from './Types/TariffsContentType'
import type { ConditionType } from './Types/ProductContent'

export const initTariffsContent = (content: any) =>
  Object.keys(content).reduce((acc, tariffName) => {
    let hasHelp = false
    acc[tariffName] = Object.keys(content[tariffName]).reduce((nameAcc, contentName) => {
      nameAcc[contentName] = content[tariffName][contentName]
      if (contentName === 'help') {
        hasHelp = true
        nameAcc[contentName] = {
          ...content.help,
          ...nameAcc[contentName]
        }
      }
      return nameAcc
    }, {})
    if (!hasHelp && content.help) {
      acc[tariffName].help = content.help
    }
    return acc
  }, {})

export const perUnitOfQuality = (price: number, suriIndex: any) =>
  Math.round(price / (parseFloat(suriIndex) || 1))

export const getDocumentsForQuote = (tariffContent: TariffContentWithKeyType, documents: DocumentType, webName: string = 'default'):
  OneQuoteDocuments =>
  Object.keys(tariffContent).reduce((documentObject, quoteKey) => {
    let documentObjectFinal = {}
    if (!tariffContent[quoteKey].insuranceCompany || !documents.default) {
      return { ...documentObject }
    }
    documentObjectFinal = {
      ...documentObjectFinal,
      ...documents.default.default,
      ...documents.default[webName]
    }

    if (documents[tariffContent[quoteKey].insuranceCompany]) {
      documentObjectFinal = {
        ...documentObjectFinal,
        ...documents[tariffContent[quoteKey].insuranceCompany].default,
        ...documents[tariffContent[quoteKey].insuranceCompany][webName],
      }
    }

    if (tariffContent[quoteKey].documents) {
      documentObjectFinal = {
        ...documentObjectFinal,
        ...tariffContent[quoteKey].documents.default,
        ...tariffContent[quoteKey].documents[webName]
      }
    }

    return documentObjectFinal
  }, {})

export const isConditionTrue = (fieldName: string, condition: ConditionType, value: Object | string | boolean) =>
  Object.keys(condition).reduce((acc, conditionType) => {
    if (conditionType === 'isNotIn') {
      return acc && !condition[conditionType].includes(value)
    } else if (conditionType === 'isIn') {
      return acc && condition[conditionType].includes(value)
    }
    return acc
  }, true)
